import { DatePipe } from '@angular/common';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/services/auth.service';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { DocumentService } from 'app/services/document.service';
import { SpinnerService } from 'app/services/spinner.service';

@Component({
  selector: 'app-list-document',
  templateUrl: './list-document.component.html',
  styleUrls: ['./list-document.component.css'],

})
export class ListDocumentComponent implements OnInit {

  @ViewChild('downloadCellTpl') downloadCellTpl: TemplateRef<any>;
  @ViewChild('statusCellTpl') statusCellTpl: TemplateRef<any>;
  @ViewChild('downloadUserCellTpl') downloadUserCellTpl: TemplateRef<any>;
  @ViewChild('actionCellTpl') actionCellTpl: TemplateRef<any>;
  @ViewChild('createDateTpl') createDateTpl: TemplateRef<any>;
  @ViewChild('descTpl') descTpl: TemplateRef<any>;

  profiledata: any;
  rows = [];
  columns = [];
  excelRows = [];
  adminUser: Boolean = false;

  defaultSort = [
    {
      prop: 'createDate',
      dir: 'desc'
    }
  ];

  header: string[] = [];

  constructor(private router: Router,
    private spinnerService: SpinnerService,
    private commonUtilService: CommonUtilService,
    private documentService: DocumentService,
    private authService: AuthService,
    private datePipe: DatePipe) {

    this.spinnerService.start();

    this.adminUser = this.authService.isAdmin();

    this.getDocumentsList();

    this.spinnerService.stop();
  }

  getDocumentsList() {
    this.documentService.getDocumentParentListByUser(this.adminUser).subscribe(data => {
      this.rows = data;
      /* console.log(this.rows); */

    });
  }

  ngAfterViewInit(): void {
    this.columns = [
      { name: 'Tipo documento', prop: 'type', sortable: true, resizeable: false, width: 160 },
      { name: 'Nome', prop: 'name', sortable: true, resizeable: false, width: 180 },
      { name: 'Descrizione', prop: 'description', cellTemplate: this.descTpl, sortable: true, resizeable: false, width: 200 },
      { name: 'Allegato', sortable: true, cellTemplate: this.downloadCellTpl, resizeable: false, width: 220, comparator: this.columnAllegatoComparator.bind(this) },
      { name: 'Data', cellTemplate: this.createDateTpl, sortable: true, resizeable: false, width: 150, comparator: this.columnCreateDateComparator.bind(this) }
    ];

    if (this.adminUser) {
      this.columns.splice(6, 0, { name: 'Utente HR', prop: 'hrUserEmail', sortable: true, resizeable: false, width: 250 });
      this.columns.splice(7, 0, { name: 'Allegato HR', sortable: true, resizeable: false, width: 220, cellTemplate: this.downloadUserCellTpl, comparator: this.columnAllegatoHRComparator.bind(this) });
      this.columns.splice(8, 0, { name: 'Data HR', prop: 'uploadedDate', sortable: true, resizeable: false, width: 150, comparator: this.columnUploadedDateComparator.bind(this) });
      this.columns.splice(9, 0, { name: 'Stato', prop: 'status', sortable: true, resizeable: false, width: 120, cellTemplate: this.statusCellTpl })
    }
    this.columns.splice(10, 0, { name: 'Azione', sortable: false, resizeable: true, cellTemplate: this.actionCellTpl })

  }

  ngOnInit() {
    this.commonUtilService.translateLang("HRWE.DOCUMENT.TITLE.DOCUMENT_LIST");
  }

  addDocument() {
    this.router.navigate([`file/create`]);
  }

  getStatusChecked(status) {
    if (status == 'OPEN') {
      return 'checked';
    }
    return '';
  }

  changeStatus($event, id) {
    var status = "CLOSE";
    if ($event.target.checked) {
      status = "OPEN";
    }
    this.spinnerService.start();
    this.documentService.changeDocumentStatus(id, status).subscribe(data => {
      this.getDocumentsList();
      this.spinnerService.stop();
    });
  }

  manageDocument(id) {
    this.router.navigate(['file/detail/' + id]);
  }

  goToHome() {
    this.router.navigate(['/home']);
  }

  columnCreateDateComparator(propA, propB, rowA, rowB) {
    if (rowA.createDate < rowB.createDate) { return -1; }
    if (rowA.createDate > rowB.createDate) { return 1; }
  }

  columnUploadedDateComparator(propA, propB, rowA, rowB) {
    if (rowA.uploadedDate != null && rowB.uploadedDate != null && rowA.uploadedDate < rowB.uploadedDate) { return -1; }
    if (rowA.uploadedDate != null && rowB.uploadedDate != null && rowA.uploadedDate > rowB.uploadedDate) { return 1; }
  }

  columnAllegatoHRComparator(propA, propB, rowA, rowB) {
    if (rowA.uploadedFile && rowA.uploadedFile.name && rowB.uploadedFile && rowB.uploadedFile.name && rowA.uploadedFile.name.toLowerCase() < rowB.uploadedFile.name.toLowerCase()) {
      return -1;
    }
    if (rowA.uploadedFile && rowA.uploadedFile.name && rowB.uploadedFile && rowB.uploadedFile.name && rowA.uploadedFile.name.toLowerCase() > rowB.uploadedFile.name.toLowerCase()) {
      return 1;
    }
  }

  columnAllegatoComparator(propA, propB, rowA, rowB) {
    if (rowA.optionalFile && rowA.optionalFile.name && rowB.optionalFile && rowB.optionalFile.name && rowA.optionalFile.name.toLowerCase() < rowB.optionalFile.name.toLowerCase()) {
      return -1;
    }
    if (rowA.optionalFile && rowA.optionalFile.name && rowB.optionalFile && rowB.optionalFile.name && rowA.optionalFile.name.toLowerCase() > rowB.optionalFile.name.toLowerCase()) {
      return 1;
    }
  }

  getAttachmentFile(name, fileBinary) {
    this.commonUtilService.downloadFile(name, fileBinary, true);
    return false;
  }

  exportToExcel(): void {

    this.spinnerService.start();

    this.excelRows = this.exportRows();

    this.commonUtilService.ExportAsExcel('Lista documento', this.excelRows, "Lista documento - HRWE.xlsx");

    this.spinnerService.stop();

  }

  exportToPDF(): void {
    this.spinnerService.start();

    this.excelRows = this.exportRows();

    this.commonUtilService.ExportAsPDF(true, this.header, this.excelRows, "Lista documento - HRWE.pdf");
    
  }

  exportRows() {

    if(this.adminUser){
      this.header = ['Tipo documento', 'Nome', 'Descrizione', 'Allegato', 'Data', 'Utente HR', 'Allegato HR', 'Data HR', 'Stato'];
      let arr = this.rows.map(row => {
        return {
          'Tipo documento': row.type,
          'Nome': row.name,
          'Descrizione': row.description ? row.description : ' ',
          'Allegato' : row.optionalFile && row.optionalFile.fileBinary ? row.optionalFile.name : ' ',
          'Data' : row.createDate,
          'Utente HR' : row.hrUserEmail,
          'Allegato HR' : row.uploadedFile && row.uploadedFile.name ? row.uploadedFile.name : ' ',
          'Data HR' : row.uploadedDate,
          'Stato' : this.commonUtilService.decodeDocumentStatus(row.status),
        }
      });
      return arr;
    } else {
      this.header = ['Tipo documento', 'Nome', 'Descrizione', 'Allegato', 'Data'];
      let arr = this.rows.map(row => {
        return {
          'Tipo documento': row.type,
          'Nome': row.name,
          'Descrizione': row.description ? row.description : ' ',
          'Allegato' : row.optionalFile && row.optionalFile.fileBinary ? row.optionalFile.name : ' ',
          'Data' : row.createDate,
        }
      });
      return arr;
    }

  }

}
